// src/components/layout/StepsBar.jsx

import { Link, useLocation } from 'react-router-dom'
import { ClipboardList, Building2, Mail } from 'lucide-react'

const steps = [
  {
    number: '1',
    title: 'CHOOSE YOUR LAB TEST',
    mobileTitle: 'Choose',
    description: 'Browse 100+ tests — No prescription needed',
    icon: ClipboardList,
    link: '/tests',
    color: 'text-blue-300'
  },
  {
    number: '2',
    title: 'WALK INTO ANY LAB',
    mobileTitle: 'Visit Lab',
    description: 'Quest & Labcorp — 4,000+ locations nationwide',
    icon: Building2,
    link: '/how-it-works',
    color: 'text-orange-300'
  },
  {
    number: '3',
    title: 'RECEIVE SECURE RESULTS',
    mobileTitle: 'Results',
    description: 'Fast & confidential — Delivered in 24-72 hours',
    icon: Mail,
    link: '/how-it-works',
    color: 'text-green-300'
  }
]

// Pages where StepsBar should be hidden
const hiddenPaths = ['/cart', '/checkout']

export default function StepsBar() {
  const location = useLocation()
  
  // Hide on specific pages
  if (hiddenPaths.includes(location.pathname)) {
    return null
  }

  return (
    <div className="bg-gradient-to-r from-primary-600 via-primary-700 to-primary-800 py-1.5 md:py-2">
      <div className="container-custom">
        
        {/* Desktop Version */}
        <div className="hidden md:flex items-center justify-center">
          {steps.map((step, index) => (
            <div key={step.number} className="flex items-center">
              <Link 
                to={step.link}
                className="flex items-center gap-2.5 px-3 py-1 hover:bg-white/5 rounded-lg transition-colors group"
              >
                {/* Icon */}
                <div className="relative">
                  <step.icon className={`w-4 h-4 ${step.color} group-hover:scale-110 transition-transform`} />
                  {index === 0 && (
                    <span className="absolute -top-1 -right-1 w-2 h-2 bg-green-400 rounded-full animate-pulse" />
                  )}
                </div>
                
                {/* Text */}
                <div>
                  <div className="flex items-center gap-1.5">
                    <span className="text-white/40 text-xs font-mono">{step.number}.</span>
                    <span className="font-semibold text-white text-xs tracking-wide">
                      {step.title}
                    </span>
                  </div>
                  <p className="text-white/50 text-[11px] leading-tight">
                    {step.description}
                  </p>
                </div>
              </Link>
              
              {/* Divider */}
              {index < steps.length - 1 && (
                <div className="w-8 lg:w-12 h-px bg-white/20 mx-2" />
              )}
            </div>
          ))}
        </div>

        {/* Mobile Version */}
        <div className="flex md:hidden items-center justify-between py-0.5">
          {steps.map((step, index) => (
            <div key={step.number} className="flex items-center">
              <Link 
                to={step.link}
                className="flex items-center gap-1.5 px-2 py-1"
              >
                <div className="relative">
                  <step.icon className={`w-4 h-4 ${step.color}`} />
                  {index === 0 && (
                    <span className="absolute -top-0.5 -right-0.5 w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse" />
                  )}
                </div>
                <div className="flex items-baseline gap-1">
                  <span className="text-white/40 text-[10px] font-mono">{step.number}.</span>
                  <span className="font-medium text-white text-xs">
                    {step.mobileTitle}
                  </span>
                </div>
              </Link>
              
              {/* Divider */}
              {index < steps.length - 1 && (
                <div className="w-4 h-px bg-white/20 mx-1" />
              )}
            </div>
          ))}
        </div>

      </div>
    </div>
  )
}